
export function updateCardInterval(card, correct = true) {
  if (!card.repetitions) card.repetitions = 0;
  if (!card.interval) card.interval = 1;
  if (!card.ease) card.ease = 2.5;

  const now = Date.now();

  if (correct) {
    card.repetitions = Math.min(card.repetitions + 1, 15);
    card.ease = Math.min(Math.max(card.ease + 0.1, 1.3), 3.0);
    card.interval = Math.min(Math.round(card.interval * card.ease), 180);
  } else {
    card.repetitions = 0;
    card.interval = 1;
    card.ease = 2.5;
  }

  card.lastSeen = now;
  card.nextReview = now + card.interval * 86400000;
  return card;
}
